export default __webpack_public_path__ + "static/media/block-svg.b538998b.svg";